"use strict";
import {
    commonConstants,
    responseCodes,
    successMessagesList,
    frontEndSuccessMessages,
} from "../_constants";
import { customErrorMessages } from "../../_helpers/custom.messages";

const messageMiddleware = (store) => (next) => (action) => {
    if (
        (action.type === commonConstants.AJAX_ERROR ||
            action.type === commonConstants.REFRESH_TOKEN_ERROR) &&
        action.payload.response != null
    ) {
        let response = action.payload.response;

        store.dispatch({
            type: commonConstants.SHOW_ERROR_SERVER_MESSAGE,
            payload: response,
        });
    }

    if (successMessagesList.includes(action.type)) {
        store.dispatch({
            type: commonConstants.AJAX_SUCCESS,
            payload: frontEndSuccessMessages[action.type],
            identity: action.type,
        });
    }

    next(action);
};

export { messageMiddleware };
